import script from "./file-access-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./file-access-edit-form.vue?vue&type=script&setup=true&lang=js"

import "./file-access-edit-form.vue?vue&type=style&index=0&id=2bac15b2&lang=css"

const __exports__ = script;

export default __exports__